<template>
    <div class="artcleMain">
        <p class="current">当前位置：<span>{{ currentName }}</span></p>
        <div class="artcle-box">
            <div class="menu">
                <el-menu
                    ref="menu"
                    @select="handleMenuSelect"
                    class="el-menu-vertical-demo"
                    default-active="1"
                    background-color="#fff"
                    active-text-color="#00a8a8"
                    :mode="widthNew?'':'horizontal'"
                    >
                        <el-menu-item index="1" @click="getListcompany1()">看政策</el-menu-item>
                        <el-menu-item index="2" @click="getExpert()">问专家</el-menu-item>
                        <el-menu-item index="3" @click="getListcompany()">找服务</el-menu-item>
                       
                </el-menu>
            </div>
            <div class="artcle-right" v-show="IsMenu != 3">
                <div class="search-page">
                    <Search class="searchWidth" @inputKey="inputKey"></Search>
                    <el-button type="primary" round @click="company()" >+企业入驻</el-button>
                </div>
                <div v-for="item in listarticle" :key="item.id" v-show="listarticle!=''">
                    <!-- 看政策 -->
                    <div v-show="IsMenu == 1">
                        <div class="content-div" @click="handleDetail(item)">
                            <img :src="item.firstFile.FileUrl" alt="" v-show="item.firstFile.FileUrl" style="object-fit: cover;">
                            <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl" style="object-fit: cover;">
                            <div>
                                <p class="title-p">{{ item.title }}</p>
                                <p class="time-p">{{ item.create_time }}</p>
                            </div>
                        
                        </div>
                        <el-divider></el-divider>
                    </div>
                    <!-- 找服务 -->
                    <div  v-show="IsMenu == 2">
                        <div class="content-div Menu2" @click="handleCompanyDetail(item)">
                            <img :src="item.firstFile.FileUrl" alt="" v-show="item.firstFile.FileUrl" style="object-fit: cover;">
                            <img src="../../assets/logo666.png" alt="" v-show="!item.firstFile.FileUrl" style="object-fit: cover;">
                            <div>
                                <p class="title-p ">{{ item.name }}</p>
                                <p class="time-p">{{ item.description }}</p>
                            </div>
                        </div>
                        <el-divider   ></el-divider>
                    </div>
                    
                
                </div>
                <div class="pagination">
                    <el-pagination
                        :hide-on-single-page="hideOnSinglePage"
                        :page-size="20"
                        :pager-count="widthNew?11:5"
                        @current-change="handleCurrentChange"
                        layout="prev, pager, next"
                        :total="total">
                    </el-pagination>
                </div>
            </div>
            <!-- 问专家 -->
            <expertList v-show="IsMenu == 3" :recommendIds="recommendIds" :type="type" :wacthMenu="wacthMenu"></expertList>
        </div>
    </div>
</template>

<script>
import Search from "../search/index.vue"
import expertList from "../expert/expertList.vue";
import { getTimeDate } from "@/js/getTime";
export default({
    data(){
        return{
            innerWidth: '',
            input: '',
            total: 0,
            hideOnSinglePage: true,
            currentChange: 1,
            cate_values: ['maintype','industry'],
            listarticle: [],
            channel: sessionStorage.getItem("channel"),
            maintype_ids: '',
            currentName: '',
            Newkeywords:'',
            recommendIds: '',
            IsMenu: 1,
            indexActive: 1,
            wacthMenu: false,
            type: 2,
            widthNew: false
        }
    },
    components: {
        Search,
        expertList
    },
    watch: {
        recommendIds(newVal,lodVal){
            this.currentName = sessionStorage.getItem("name")
            this.channel = sessionStorage.getItem("channel")
            this.recommendIds = sessionStorage.getItem("recommendIds")
            let data = {
                channel: sessionStorage.getItem("channel"),
                pageNum: 1,
                pageSize: 10,
                recommendIds: sessionStorage.getItem("recommendIds"),
                keywords: ''
            }
            if(this.indexActive == 1){
                this.getListArry(data)
            }else if(this.indexActive == 3){
                this.IsMenu = 2
                let data = {
                    pageNum: 1,
                    pageSize: 20,
                    cates: sessionStorage.getItem("recommendIds"),
                    keywords: ''
                }
                this.getIndexActive(data)
            }
            
            
        }
      
    },
    methods:{
        handleMenuSelect(index) {
            
            this.indexActive = index
        },
        //   根据不同的channel来查询
        getListArry(data){
            this.listarticle = []
            this.$store.dispatch('menu/ChannelPolicyList',data)
                .then(res => {
                
                    if(res.ok){
                        if(res.data.items != ''){
                            this.listarticle = res.data.items
                        }
                        this.total = res.data.total

                        if(this.total <= 20){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                    this.listarticle.map(item => {
                        item.create_time = getTimeDate(item.create_time)
                    })

                   


                }).catch(err => {
                    console.log(err);s
                })
        },
        getListcompany1(){
            this.IsMenu = 1
            let data = {
                channel: sessionStorage.getItem("channel"),
                pageNum: 1,
                pageSize: 10,
                recommendIds: this.recommendIds,
                keywords: ''
            }
            
            this.getListArry(data)
        },
        getListcompany(){
            this.IsMenu = 2
            let data = {
                pageNum: 1,
                pageSize: 20,
                cates: this.recommendIds,
                keywords: ''
            }
            this.getIndexActive(data)
            
        },
        getExpert(){
            this.IsMenu = 3
            this.type = 2
            this.wacthMenu = !this.wacthMenu
        },
        getIndexActive(data){
            this.listarticle = []
            this.$store.dispatch('menu/listcompany',data)
                .then(res => {
                    if(res.ok){
                        if(res.data.items != ''){
                            this.listarticle = res.data.items
                        }
                        this.total = res.data.total
                        
                        if(this.total <= 10){
                            this.hideOnSinglePage = true
                        }else{
                            this.hideOnSinglePage = false
                        }
                    }
                })
        },
        company(){
            this.$router.push({
                path: '/join'
            })
        },  

        handleCurrentChange(val){
            console.log(`当前页: ${val}`);
            this.currentChange = val
            let data = {
                channel: this.channel,
                pageNum: val,
                pageSize: 20,
                recommendIds: this.recommendIds,
                keywords: this.Newkeywords
            }
            this.getListArry(data)
        },
        handleDetail(item){
            const { href } = this.$router.resolve({
                path: "/detailPages",
                query: {
                    key: item.id,
                    currentName: this.currentName
                }
            });
            window.open(href, '_blank');
        },
        handleCompanyDetail(item){
        
          const { href } = this.$router.resolve({
                path: "/companyDetail",
                query: {
                    key: item.id,
                    currentName: '公司详情'
                }
            });
            window.open(href, '_blank');
        },  
        inputKey(val){
            this.Newkeywords = val
            let data = {
                channel: this.channel,
                pageNum: 1,
                pageSize: 20,
                recommendIds: this.recommendIds,
                keywords: this.Newkeywords
            }

            this.getListArry(data)
        }
    },
    mounted(){
        
    },
    
    created(){
        let widthNew = document.documentElement.clientWidth
        if(widthNew > 540){
            this.widthNew = true
        }else{
            this.widthNew = false
        }
       
        window.addEventListener('setItem', ()=> {
            this.recommendIds = sessionStorage.getItem('recommendIds');
        })

        this.currentName = sessionStorage.getItem("name")
        this.channel = sessionStorage.getItem("channel")
        this.recommendIds = sessionStorage.getItem("recommendIds")
    //    if(this.$route.query.channel == 'law'){
        let data = {
            channel: this.channel,
            pageNum: 1,
            pageSize: 10,
            recommendIds: this.recommendIds,
            keywords: ''
        }
        
        this.getListArry(data)
    }
})
</script>

<style>
@import url(../../css/channelPolicy.css);
@import url(../../css/channelPolicy540.css);
</style>